import React from 'react';
import { titleize } from 'underscore.string';
import { sluggify } from '../../../utils/localization/utils';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

/*
 * The component is for rendering reference numbers of the following schema:
 *
 * [{
 *   name: "Mike"
 *   value: "Seay"
 * }]
 *
 * The intention is to wrap this in a container div to control the width.
 */

const ReferenceNumbersList = (props) => {
  const reference_numbers = props.reference_numbers;

  return (
    <div className="grid grid-cols-2 grid-gap-4 overflow-hidden">
      {reference_numbers.map((reference, idx) => (
        <ReferenceNumber
          className="mb-3"
          key={reference.value + idx}
          reference={reference}
        />
      ))}
    </div>
  );
};

ReferenceNumbersList.propTypes = {
  reference_numbers: PropTypes.array,
};

ReferenceNumbersList.defaultProps = {
  reference_numbers: [],
};

const ReferenceNumber = ({ reference, className }) => {
  const { t } = useTranslation();
  return (
    <div className={`${className} min-w-0`} data-testid={reference.name}>
      <dt
        className="text-sm font-medium text-gray-500 truncate"
        title={titleize(t(sluggify(reference.name)))}
      >
        {titleize(t(sluggify(reference.name)))}
      </dt>
      <dd
        className="mt-1 text-sm text-gray-900 truncate"
        title={reference.value}
      >
        {reference.value}
      </dd>
    </div>
  );
};

ReferenceNumber.propTypes = {
  reference: PropTypes.object,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.object,
  ]),
};

export default ReferenceNumbersList;
